/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive} from '@angular/core';
/**
 * \@whatItDoes Adds `novalidate` attribute to all forms by default.
 * 
 * `novalidate` is used to disable browser's native form validation.
 * 
 * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
 * 
 * ```
 * <form ngNativeValidate></form>
 * ```
 * 
 * \@experimental
 */
export class NgNoValidate {
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'form:not([ngNoForm]):not([ngNativeValidate])',
  host: {'novalidate': ''},
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgNoValidate_tsickle_Closure_declarations() {
/** @type {?} */
NgNoValidate.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgNoValidate.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
